
export default function ScheduleVisit() {
  return (
    <section id="contato" className="py-20 bg-gradient-to-br from-slate-700 via-slate-800 to-slate-900 text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-64 h-64 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-red-400 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 relative z-10">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            AGENDE SUA VISITA AGORA!
          </h2>
          <p className="text-2xl md:text-3xl mb-8 flex items-center justify-center gap-2">
            Você é nosso convidado especial <span className="text-red-400">❤️</span>
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-8 shadow-2xl border border-white/20">
            <img 
              src="https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/6b05dd06bff02a4e736011e6ffed48b9.png"
              alt="The Joy School Paulínia - Agende sua visita"
              className="w-full h-auto rounded-2xl shadow-xl mb-8 object-cover object-top"
            />
            <a 
              href="https://wa.me/5519989250972?text=Olá,%20vi%20o%20site%20e%20gostaria%20de%20agendar%20uma%20visita%20à%20The%20Joy%20School%20Paulínia."
              className="block w-full bg-gradient-to-r from-red-500 to-red-600 text-white px-8 py-5 rounded-full font-bold text-xl text-center hover:from-red-600 hover:to-red-700 transition-all transform hover:scale-105 shadow-2xl whitespace-nowrap cursor-pointer"
            >
              Agendar Visita
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
